import { fetchApi } from '../utils/api';

export interface Patient {
  id: string;
  firstName: string;
  lastName: string;
  email: string;
  phone: string;
  gender: string;
  birthDate: string;
  address: string;
  dateOfBirth: string;
  lastVisit: string;
  nextAppointment?: string;
  status: 'active' | 'inactive' | 'new';
  medicalConditions: string[];
  insurance: string;
  totalVisits: number;
  // Extended patient info (from backend)
  whatsappPhone?: string;
  profession?: string;
  cinNumber?: string;
  referredBy?: string;
  medicalHistoryAllergies?: string;
  medicalHistoryDiseases?: string;
  medicalHistoryMedications?: string;
  familyHeadId?: string;
  relationshipToHead?: string;
  medical_history_allergies?: string;
  medical_history_diseases?: string;
  medical_history_medications?: string;
  cin_number?: string;
}

export interface CreatePatientRequest {
  first_name: string;
  last_name: string;
  email: string;
  phone_number: string;
  gender: string;
  date_of_birth: string;
  address: string;
  whatsapp_phone?: string;
  profession?: string;
  cin_number?: string;
  referred_by?: string;
  insurance?: string;
  medical_history_allergies?: string;
  medical_history_diseases?: string;
  medical_history_medications?: string;
  family_head_id?: string;
  relationship_to_head?: string;
}

export interface UpdatePatientRequest extends Partial<CreatePatientRequest> {}

export const patientService = {
  // Fetch all patients
  async getPatients(): Promise<Patient[]> {
    const response = await fetchApi('patients/api/list/');
    if (response.success) {
      return response.patients;
    } else {
      throw new Error(response.message || 'Failed to fetch patients');
    }
  },

  // Create a new patient
  async createPatient(patientData: CreatePatientRequest): Promise<{ success: boolean; patient_id?: string; message: string }> {
    return await fetchApi('patients/api/create/', {
      method: 'POST',
      body: JSON.stringify(patientData)
    });
  },

  // Update an existing patient
  async updatePatient(patientId: string, patientData: UpdatePatientRequest): Promise<{ success: boolean; patient_id?: string; message: string }> {
    return await fetchApi(`patients/api/${patientId}/update/`, {
      method: 'PUT',
      body: JSON.stringify(patientData)
    });
  }
};
